import { DTOCustomFieldOption, DTOGetDefaultOption } from '../../../generated-common';
import React, { useState } from 'react';
import { CustomFieldType, AuthenticatedUserCapabilities } from '../../../model/model';
import { FieldEditorStateful } from './FieldEditorStateful';
import { DefaultOptionHelper } from 'shared-components/stateless/default-option/DefaultOptionHelper';

// This is the outer upmost Container for the field editor
// That holds state such as field, context and defaultOption
export const FieldEditorStatefulWrapper = ({
  customFieldId,
  contextId,
  fieldType,
  initialDefaultOption,
  authenticatedUserCapabilities,
}: {
  customFieldId: string;
  contextId: number;
  fieldType: CustomFieldType;
  initialDefaultOption: DTOGetDefaultOption;
  authenticatedUserCapabilities: AuthenticatedUserCapabilities;
}) => {
  const [defaultOption, setDefaultOption] = useState<DTOGetDefaultOption>(initialDefaultOption);
  const onOptionDeletedForDefaultOptionUpdate = (parentIds: string[] | null, option: DTOCustomFieldOption) => {
    const hasDefaultChange = DefaultOptionHelper.updateDefaultOptionStateOnDelete(fieldType, defaultOption, option, parentIds);
    if (hasDefaultChange.hasChange) {
      setDefaultOption(hasDefaultChange.defaultOption);
    }
  };

  return (
    <>
      <FieldEditorStateful
        parentOptionIds={null}
        customFieldId={customFieldId}
        contextId={contextId}
        defaultOption={defaultOption}
        setDefaultOption={setDefaultOption}
        onOptionDeletedForDefaultOptionUpdate={onOptionDeletedForDefaultOptionUpdate}
        fieldType={fieldType}
        authenticatedUserCapabilities={authenticatedUserCapabilities}
      />
    </>
  );
};
